














































import Vue, {PropType} from 'vue'
import {mostrarModalDeResposta} from 'src/typescript/utils'
import { DRegraDeNotificacao } from 'src/tipos'
import TiposDeNotificacao from './TiposDeNotificacao'

interface Data {
  carregando: boolean;
}

interface Methods {
  editarRegraDeNotificacao: () => void;
  deletarRegraDeNotificacao: () => Promise<void>;
}

interface Computed {
  possuiPermissaoEditarRegra: boolean;
  possuiPermissaoDeletarRegra: boolean;
}

interface Props {
  detalhes: DRegraDeNotificacao;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  name: 'RegrasDeNotificacaoDetalhes',

  components: {TiposDeNotificacao},

  props: {
    detalhes: {
      type: Object as PropType<DRegraDeNotificacao>,
      required: true
    }
  },

  data () {
    return {
      carregando: false
    }
  },

  computed: {
    possuiPermissaoEditarRegra (): boolean {
      const possuiPermissaoDeEditar = this.$hasPermission({
        module: 'notificationrules',
        action: 'post'
      })
      const usuarioLogadoId = this.$store.state.userInfo.id
      const ehUsuarioEmpregadoDonoDaRegra = this.detalhes.usuariosNotificados.includes(usuarioLogadoId)
      return possuiPermissaoDeEditar || ehUsuarioEmpregadoDonoDaRegra
    },

    possuiPermissaoDeletarRegra (): boolean {
      const possuiPermissaoDeDeletar = this.$hasPermission({
        module: 'notificationrules',
        action: 'delete'
      })
      const usuarioLogadoId = this.$store.state.userInfo.id
      const ehUsuarioEmpregadoDonoDaRegra = this.detalhes.usuariosNotificados.includes(usuarioLogadoId)
      return possuiPermissaoDeDeletar || ehUsuarioEmpregadoDonoDaRegra
    }
  },

  methods: {
    editarRegraDeNotificacao (): void {
      this.$router.push({
        name: 'regrasDeNotificacao.edicao',
        params: {
          id: this.detalhes.id as string
        }
      })
    },

    async deletarRegraDeNotificacao (): Promise<void> {
      this.carregando = true
      const idDaRegraParaDeletar = (this.detalhes.id as string)
      console.log(idDaRegraParaDeletar)
      const resultado = await this.$API.regrasDeNotificacao.delete({ id: idDaRegraParaDeletar })
      console.log(resultado)
      await mostrarModalDeResposta(resultado, {
        modalDeSucesso: this.$modalDeSucesso,
        modalDeErro: this.$modalDeErro
      })
      this.carregando = false
    }
  }
})
